<template>
   <div class="childOutbound-wrap">
     <el-descriptions border class="child-outbound-description" :title="`客户：${list.company}`" :column="getIsMobile?1:3">
       <el-descriptions-item label="商品编码">{{list.id}}</el-descriptions-item>
       <el-descriptions-item label="品牌">{{list.source}}</el-descriptions-item>
       <el-descriptions-item label="型号">{{list.xhname}}</el-descriptions-item>
       <el-descriptions-item label="进货（未税）价格">{{list.wshui}}</el-descriptions-item>
       <el-descriptions-item label="进货（含税）价格">{{list.hshui}}</el-descriptions-item>
       <el-descriptions-item label="是否含税">{{list.sfkp == '2' ? '未税' : '含税'}}</el-descriptions-item>
       <el-descriptions-item label="最终价格" :labelStyle="{color:'red'}">{{list.price}}</el-descriptions-item>
       <el-descriptions-item label="进货日期">{{list.settime}}</el-descriptions-item>
       <el-descriptions-item label="收票状态">{{list.sfsp == '0' ? '未税': list.sfsp == '1' ?'已到' : '未到'}}</el-descriptions-item>
       <el-descriptions-item label="供应商">{{list.gongyingshang}}</el-descriptions-item>
       <el-descriptions-item label="总价">
         <span style="color: red">{{totalPrice}}</span>
         <el-input style="width: 40%" size="mini" placeholder="请输入出库数量" class="child-outbound-input" v-model="num" @input="handleBlur"/>
       </el-descriptions-item>
     </el-descriptions>
     <div slot="footer" class="dialog-footer">
       <el-button @click="handleClose">取 消</el-button>
       <el-button type="primary" @click="handleOutbound" :loading="submitLoading">出 库</el-button>
     </div>
   </div>
</template>
<script>
import {defineComponent, onMounted, ref, reactive, watch, nextTick} from '@vue/composition-api'
import request from '@/utils/request'
import { Message } from 'element-ui'
import useRootSetting from '@/hooks/useRootSetting';
export default defineComponent({
  components: {},
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    childId: {
      type: [Number,String],
      default: 0
    },
    parentId: {
      type: [Number,String],
      default: 0
    },
    outboundNum: {
      type: [Number,String],
      default:0
    },
    contractNum: {
      type: [Number,String],
      default:0
    }
  },
  setup(props, { emit }) {
    const {getIsMobile} = useRootSetting()
    const num = ref()
    const list = reactive({
      cid: '',
      gongyingshang:'',
      id:'',
      price:'',
      number:'',
      sfkp:'',
      sfsp:'',
      title:'',
      xhname:'',
      source:'',
      address:'',
      baozhuang:'',
      company:'',
      htprice:'',
      number_kc:''
    })
    const totalPrice = ref()
    const submitLoading = ref(false)
    const getDetailOutbound = () => {
      request({
        url: 'out_wareh_record.yy',
        method: 'post',
        data: {
          id_f: props.parentId,
          id_s: props.childId
        }
      }).then(res => {
        Object.assign(list, res.data);
      })
    }
    onMounted(()=>{
      getDetailOutbound()
    })

    const handleBlur = () => {
      totalPrice.value = (Number(list.price) * num.value).toFixed(2)
    }


    const handleClose = () => {
      emit('close')
    }

    const handleOutbound = () => {
      list.number = num.value
      if(!num.value){
        Message.error('请填写出库数量！')
        return;
      }
      submitLoading.value = true
      request({
        url: 'out_wareh_insert.yy',
        method: 'post',
        data: list
      }).then(res => {
        if(res.code == 200){
          submitLoading.value = false
          emit('outboundSuccess',res.code)
        }else if(res.code == 400) {
          Message.error(res.msg)
          submitLoading.value = false
        }
      })
    }
    watch(()=>list.price,(val)=>{
      //默认展示合同数量，如果库存数量少于合同数量，那展示库存数量就好了 库存>合同 展示合同
      if(Number(props.outboundNum) < Number(props.contractNum)) {
        num.value = props.outboundNum
      }else{
        num.value = props.contractNum
      }
        totalPrice.value = (Number(list.price) * num.value).toFixed(2)
    },{immediate:true})
    return {
      getIsMobile,
      handleOutbound,
      handleClose,
      handleBlur,
      submitLoading,
      totalPrice,
      list,
      num
    }
  }
})
</script>
<style lang="scss">
.childOutbound-wrap {
  padding-bottom: 40px;
  .child-outbound-description {
    padding-top: 10px;
    margin: 0 20px;
    .child-outbound-input {
      margin-left: 10px;
    }
  }
  .dialog-footer {
    float: right;
    margin-top: 13px;
  }
}

</style>
